import useBindActionCreators from 'common/hooks/useBindActionCreators';

import { cardOperations } from '../store';

export const useCardOperations = (): typeof cardOperations => {
  const bindedActions = useBindActionCreators(cardOperations);
  return bindedActions;
};
